/*** IMPORTS FROM imports-loader ***/
var define = false;

// This is required in order to process your main style file.
// DO NOT REMOVE OR MODIFIY THIS!
require("src:styles/square360.homepage.scss");

// The is a required alias to all the static images inside the "src" folder.
// These images are in stylesheets and/or a <img> tags.
// The second argument decides if sub directories should also be searched.
// DO NOT REMOVE OR MODIFIY THIS!
require.context("src:images", true, /\.(gif|png|jpe?g|svg)$/);

/**
 * PARTIALS
 * **************************************************
 */
require("partials/homepage-fullscreen.js");
require("partials/homepage-particles.js");

